import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { ErrorInfo } from 'next/dist/client/components/error-boundary';
export function ErrorComponent(t0) {
  const $ = _c(2);
  const {
    error
  } = t0;
  const message = typeof error === "object" && error && "message" in error ? String(error.message) : "An unknown error occurred";
  let t1;
  if ($[0] !== message) {
    t1 = <>Error loading diagram: {message}</>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}